module.exports = __webpack_public_path__ + "static/media/receipt.621ccad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/SSP/receipt.png
// module id = 67
// module chunks = 0